import type { User } from '@halo/chat-sdk-react';
import {
  isSessionCategory,
  SessionCategoryPrefix,
  type SessionStoreInstance,
} from '@halo/chat-sdk-react';
import { useStore } from 'zustand';
import { useActionsStore } from '@/store/actions';
import { TransferDialog } from './TransferDialog';
import { TransferDetailDialog } from './TransferDetailDialog';
import { TransferToDialog } from './TransferToDialog';
import { TransferConfirmDialog } from './TransferConfirmDialog';

interface TransferProps {
  sessionStoreInstance: SessionStoreInstance;
}
export function Transfer({ sessionStoreInstance }: TransferProps) {
  const sessionStore = useStore(sessionStoreInstance);
  const isGroup = useMemo(() => {
    return isSessionCategory(sessionStore?.session?.chat_id, SessionCategoryPrefix.Group);
  }, [sessionStore]);
  const {
    transferToIsOpen,
    setTransferToIsOpen,
    transferDialogIsOpen,
    setTransferDialogIsOpen,
    transferConfirmDialogIsOpen,
    transferConfirmDialogData,
    setTransferConfirmDialogIsOpen,
    transferDetailDialogIsOpen,
    transferDetailsDialogData,
    setTransferDetailDialogIsOpen,
  } = useActionsStore();

  const [sendTo, setSendTo] = useState<User>();

  const handleTransferToClick = useCallback(
    (member: User) => {
      setSendTo(member);
      setTransferToIsOpen(false);
      setTransferDialogIsOpen(true);
    },
    [setTransferDialogIsOpen, setTransferToIsOpen]
  );

  const handleTransfer = (data: any) => {
    setTransferConfirmDialogIsOpen(true, data);
  };

  const handleTransferConfirm = () => {
    setTransferDialogIsOpen(false);
    setTransferConfirmDialogIsOpen(false, null);
  };

  return (
    <>
      <TransferToDialog
        isOpen={transferToIsOpen}
        setIsOpen={(isOpen) => setTransferToIsOpen(isOpen)}
        sessionId={sessionStore?.session?.chat_id}
        handleTransferToClick={handleTransferToClick}
      />

      <TransferDialog
        sendTo={isGroup ? sendTo : sessionStore?.session?.user_info}
        isOpen={transferDialogIsOpen}
        setIsOpen={setTransferDialogIsOpen}
        sessionStore={sessionStore}
        onConfirm={handleTransfer}
      ></TransferDialog>

      <TransferConfirmDialog
        isOpen={transferConfirmDialogIsOpen}
        setIsOpen={setTransferConfirmDialogIsOpen}
        sessionStore={sessionStore}
        transferConfirmDialogData={transferConfirmDialogData}
        onConfirm={handleTransferConfirm}
      ></TransferConfirmDialog>

      <TransferDetailDialog
        isOpen={transferDetailDialogIsOpen}
        setIsOpen={setTransferDetailDialogIsOpen}
        sessionStore={sessionStore}
        transferDetailsDialogData={transferDetailsDialogData}
      ></TransferDetailDialog>
    </>
  );
}
